module.exports = __webpack_public_path__ + "fonts/source-serif-pro-v11-latin-regular.86abe65.woff";